import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Map, BookOpen, Wrench, Settings } from 'lucide-react';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState(null);

  const navItems = [
    { id: 'tools', label: 'Tools', icon: Wrench, path: '/public-tools' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t safe-area-bottom z-50"
      style={{ 
        borderTopColor: '#E5E7EB',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.06)'
      }}
      data-testid="bottom-navigation"
    >
      <div className="max-w-screen-lg mx-auto flex items-center justify-around h-16 px-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const isHovered = hoveredItem === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
              className="flex flex-col items-center justify-center flex-1 h-full relative transition-all duration-150"
              style={{ 
                color: active ? '#001F3F' : (isHovered ? '#374151' : '#6B7280'),
                minWidth: '64px',
                padding: '8px 4px',
              }}
              data-testid={`nav-${item.id}`}
              aria-label={item.label}
              aria-current={active ? 'page' : undefined}
            >
              {active && (
                <div 
                  className="absolute top-0 left-1/2 w-12 rounded-full" 
                  style={{ 
                    height: '2px', 
                    backgroundColor: '#001F3F',
                    transform: 'translateX(-50%)'
                  }} 
                />
              )}
              <div 
                className="flex items-center justify-center rounded-lg transition-all duration-150"
                style={{
                  width: '40px',
                  height: '32px',
                  backgroundColor: isHovered && !active ? '#F3F4F6' : 'transparent',
                  transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                }}
              >
                <Icon 
                  className="w-6 h-6" 
                  strokeWidth={active ? 2.5 : 2} 
                  style={{
                    transition: 'transform 150ms ease',
                  }}
                />
              </div>
              <span 
                className="text-xs mt-0.5"
                style={{ 
                  fontWeight: active ? 600 : 400,
                  transition: 'color 150ms ease',
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;